import BadgesValueV2 from "../BadgesValueV2";
import VotingBadgeRequirements from "./VotingBadgeRequirements";

export default class PotmBadgesValue extends BadgesValueV2 {
  public requirements: VotingBadgeRequirements = new VotingBadgeRequirements();
}
